import { cx } from '@linaria/core';
import { useRef } from 'react';
import { useKatex } from '@pm2/react-utils';
import { avoidBreakInside, avoidBreakSnapPoint } from '@provider/print';
import { PostloadedImage } from '@utils/react';
import { usePageContext } from '../../../../context.js';
import { CircledAudioPlayer } from '../../../atom.audio/_audio-player.circled.js';
import { useTaskContext } from '../../context.js';
import { content, tileSelectors } from './_tile-input.style.js';
import { TileMoveIcon } from './atom.move-icon.js';
import { StateIcon } from './atom.state-icon.js';
import { image, content as content$1, imageAudio } from './tile.image.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ImageTile(props) {
  const context = useTaskContext();
  const pageContext = usePageContext();
  const ref = useRef(null);
  useKatex(ref);
  return /*#__PURE__*/jsxs("div", {
    className: cx(content, image, props.className),
    "data-id": props.id,
    "data-type": "image",
    "data-state": props.state,
    "data-size": props.size,
    "data-theme": props.facitTheme,
    "data-context": context,
    "data-page-context": pageContext,
    "data-is-draggable": props.isDraggable,
    "data-is-overlay": props.isDragOverlay,
    ...avoidBreakInside({
      extend: {
        bottom: 10,
        top: 18
      }
    }),
    ...avoidBreakSnapPoint(),
    children: [/*#__PURE__*/jsxs("div", {
      className: cx(content$1, tileSelectors.content.className),
      children: [/*#__PURE__*/jsx(PostloadedImage, {
        src: props.src,
        alt: ""
      }), props.audioSrc && /*#__PURE__*/jsx(CircledAudioPlayer, {
        className: imageAudio,
        src: props.audioSrc
      })]
    }), /*#__PURE__*/jsx(TileMoveIcon, {
      ...props
    }), /*#__PURE__*/jsx(StateIcon, {
      ...props
    })]
  });
}

export { ImageTile };
//# sourceMappingURL=tile.image.js.map
